const  Births = ()=> import('@/views/ADMIN/BirthsView.vue')

export const births = {
    path: "/nacimientos",
    name: "Nacimientos",
    meta: { requiresAuth: true},
	component: Births
};